import axios from "axios";
import logger from "./logService";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(null, error => {
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 501;

    if (!expectedError) {
        logger.log(error)
    }

    return Promise.reject(error);
});

function setToken(sessionToken) {
    axios.defaults.headers.common['Authorization'] = sessionToken;
}

function getDataOrError(response){
    if (response.data.success) {
        return response.data.data;
    } else {
        let error = new Error(response.data.message);
        error.name = response.data.error;
        error.status = response.data.status;
        throw error;
    }
}

const inflight = new Map();
const cache = new Map();

function cacheKey(url, opts) {
    return url + (opts && opts.params ? JSON.stringify(opts.params) : '');
}

function cachedGet(url, opts = {}, ttlMs = 60000) {
    const key = cacheKey(url, opts);
    const now = Date.now();
    const hit = cache.get(key);
    if (hit && hit.expires > now) return Promise.resolve(hit.data);
    if (inflight.has(key)) return inflight.get(key);
    const p = axios.get(url, opts).then(r => {
        cache.set(key, { data: r, expires: now + ttlMs });
        inflight.delete(key);
        return r;
    }).catch(e => {
        inflight.delete(key);
        throw e;
    });
    inflight.set(key, p);
    return p;
}

function invalidateCache(prefix) {
    for (const k of Array.from(cache.keys())) {
        if (k.startsWith(prefix)) cache.delete(k);
    }
}


export default {
    get: axios.get,
    cachedGet,
    invalidateCache,
    post: axios.post,
    put: axios.put,
    patch: axios.patch,
    delete: axios.delete,
    setToken,
    CancelAxiosToken: axios.CancelToken,
    isCancel: axios.isCancel,
    getDataOrError
};
